import * as React from 'react';
import { PageProps } from 'gatsby';
import Layout from '../components/Layout';
import { EquationContainer } from '../components/Equations/EquationContainer';
import { WavelengthComponent } from '../components/Equations/WavelengthComponent';

export default function TankCircuitPage(props: PageProps): JSX.Element {
  const pageTitle = 'Wavelength';

  return (
    <Layout location={props.location} title={pageTitle}>
      <EquationContainer>
        <WavelengthComponent />
      </EquationContainer>
    </Layout>
  );
}
